import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BUNDLE_LIST, BUNDLES } from "@/data/bundles";
import { fetchProductsByCollection } from "@/lib/shopify";
import ProductCard from "@/components/ProductCard";

// Other pieces from the same box collection, shown under the PDP
export const MoreFromBox = ({ product, boxSlug }) => {
  const handles = product.collectionHandles || [];
  const box = BUNDLES[boxSlug] || BUNDLE_LIST.find((b) => b.collectionHandles.some((h) => handles.includes(h)));
  const [items, setItems] = useState([]);
  const key = box?.collectionHandles.join(",");

  useEffect(() => {
    if (!key) return;
    let cancelled = false;
    (async () => {
      for (const h of key.split(",")) {
        const list = (await fetchProductsByCollection(h, { first: 13 }).catch(() => [])).filter(Boolean);
        if (list.length) {
          if (!cancelled) setItems(list.filter((p) => p.id !== product.id).slice(0, 12));
          return;
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [key, product.id]);

  if (!box || !items.length) return null;

  return (
    <section className="py-14 lg:py-20 border-t border-sectionbreak" style={{ background: box.softBg }} data-testid="pdp-more-from-box">
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 lg:mb-10">
          <div>
            <p className="text-[10px] tracking-[0.4em] uppercase font-semibold" style={{ color: box.accent }}>
              {box.qty} for ₹{box.price.toLocaleString("en-IN")}
              {box.hasFreeGift ? " + Free Gift" : ""}
            </p>
            <h2 className="font-serif text-plum leading-[1] tracking-tight mt-2" style={{ fontSize: "clamp(28px, 3.6vw, 44px)" }}>
              More from the <span className="italic" style={{ color: box.accent }}>{box.name}</span>
            </h2>
          </div>
          <Link
            to={`/bundle/${box.slug}`}
            className="self-start sm:self-auto inline-flex items-center gap-2 px-6 py-3 rounded-full bg-plum text-cream text-[11px] tracking-[0.26em] uppercase font-semibold transition-transform hover:-translate-y-0.5"
            data-testid="pdp-build-box-link"
          >
            Build your box <ArrowRight size={14} />
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-7">
          {items.map((p) => (
            <ProductCard key={p.id} product={p} search={`?box=${box.slug}`} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default MoreFromBox;
